export default __webpack_public_path__ + "static/media/amm-icon.0f5909d3.svg";